import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AuthenticationService } from "app/auth/service";
import { convertToUUID } from "app/main/helpers/binaryData";
import { CustomerService } from "app/main/services/customer.service";
import {
  CountryModel,
  CustomCountryModel,
  IntlInputPhoneService,
} from "intl-input-phone";
import {
  assignIn,
  findIndex,
  intersectionWith,
  orderBy,
} from "lodash";

@Component({
  selector: "input-phone",
  templateUrl: "./input-phone.component.html",
  styleUrls: ["./input-phone.component.scss"],
})
export class InputPhoneComponent implements OnInit {
  public countries: CustomCountryModel[] = [];
  public phone: string = "";
  public isValid = true;
  public defaultConfig: InputPhoneConfig = {
    flag: true,
    isoCode: true,
    phoneCode: true,
    name: false,
  };
  public regx = "";
  country = {
    InputMasking: "",
    CountryPhoneCode: "",
  };
  public convertToUUID = convertToUUID;
  private multiPrefix = {
    DO: ["1 (809)", "1 (829)", "1 (849)"],
  };

  @Input() field: FormControl;
  @Input() company: string;
  @Input() config: any;
  @Input() phoneCode: string;
  @Output() selected: EventEmitter<CountryModel> =
    new EventEmitter<CountryModel>(null);
  @Output() valueChanged = new EventEmitter<boolean>();

  constructor(
    private _company: CustomerService,
    private _auth: AuthenticationService,
    private _intlInputPhoneService: IntlInputPhoneService
  ) {}

  ngOnInit(): void {
    this.company = !this.company ? this._auth.companyId : this.company;
    this.config = assignIn(this.defaultConfig, this.config);
    this.getRouteCountries();

    this.field.valueChanges.subscribe((val) => {
      if (val === "" || !val) {
        this.phone = "";
      }
    });
  }

  getRouteCountries = (): void => {
    this._company.getCompanyCountries(this.company).subscribe(
      (countries: any[]) => {
        console.log(countries);
        this.countries = intersectionWith(
          this._intlInputPhoneService.GetCountryList(),
          countries,
          (a: any, b: any) => a.ISOCode === b.isoCode
        );

        console.log(this.countries);
        if (this.countries.length === 0)
          console.error("No tiene paises el cliente");
        const hn = findIndex(
          this.countries,
          (country) => country.ISOCode.trim() === "HN"
        );

        this.select(this.countries[hn !== -1 ? hn : 0]);

        if (this.phoneCode) {
          const find = this.countries.findIndex(
            (country) => country.CountryPhoneCode.trim() === this.phoneCode
          );
          const country = this.countries[find];
          this.select(country);
          this.phone = this.getDigits(this.field.value);
        }

        this.checkMultiPrefix();
      },
      (err: HttpErrorResponse) =>
        console.error("Error al obtener paises de la ruta", err)
    );
  };

  select = ($event): void => {
    this.country = $event;
    this.country.InputMasking = this.country.InputMasking.replace(
      new RegExp("[0-9]", "g"),
      "0"
    );
    const special = "-_.,";
    this.regx = "";

    for (let i = 0; i < this.country.InputMasking.length; i++) {
      const char = this.country.InputMasking[i];
      this.regx += /^\d+$/.test(char)
        ? "\\d"
        : !new RegExp(special).test(char)
        ? "\\" + char
        : char;
    }
    if (this.country.CountryPhoneCode)
      // console.log('REGEX', this.regx);
      this.phone = "";
    this.selected.emit($event);
  };

  inputValue = (val: string): void => {
    this.isValid = new RegExp(this.regx).test(val) ? true : false;
    this.valueChanged.emit(this.isValid);

    if (this.field) {
      if (this.isValid) this.field.setErrors({ incorrect: true });
      else this.field.setErrors(null);
      const fieldValue = `${this.getDigits(this.country.CountryPhoneCode)}${val
        .replace(/\D/g, "")
        .trim()}`;
      this.field.setValue(Number(fieldValue));
    }
  };

  checkMultiPrefix = () => {
    const stackPrefix: CustomCountryModel[] = [];

    this.countries.forEach((item) => {
      const { ISOCode, CountryPhoneCode } = item;
      if (ISOCode in this.multiPrefix) {
        const prefix = this.multiPrefix[ISOCode];
        prefix.forEach((prefix) => {
          const prefixDigits = this.getDigits(CountryPhoneCode);
          if (!CountryPhoneCode.includes(prefix)) {
            stackPrefix.push({
              ...item,
              CountryPhoneCode: prefix,
            });
          }
        });
      }
    });
    this.countries = orderBy(
      this.countries.concat(stackPrefix),
      ["ISOCode"],
      ["asc"]
    );
  };

  getDigits = (value: string) => value.match(/[0-9]+/g).join("");
}

interface InputPhoneConfig {
  flag: boolean;
  isoCode: boolean;
  name: boolean;
  phoneCode: boolean;
}
